<app-home-fundamentals-card [type]="cardType" [content]="contentTemplate" [actions]="actionsTemplate">
</app-home-fundamentals-card>

<ng-template #contentTemplate>
    <ng-container *ngIf="releaseNotes$ | async as releaseNotes; else loadingContent">
        <ul *ngIf="releaseNotes?.links?.length > 0">
            <ng-container *ngFor="let link of releaseNotes.links">
                <li>
                    <button
                        (click)="handleOpenDialog(link)"
                        [matTooltip]="'View ' + link.text + ' release notes'"
                        [matTooltipShowDelay]="1000"
                        [matTooltipHideDelay]="2000"
                        aria-haspopup="dialog"
                        [attr.data-analytics]="link.dataAnalytics?.join('-')">
                        {{ link.label }}
                    </button>
                </li>
            </ng-container>
        </ul>
    </ng-container>
    <ng-template #loadingContent>
        <ul>
            <li><app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton></li>
            <li><app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton></li>
            <li><app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton></li>
        </ul>
    </ng-template>
</ng-template>

<ng-template #actionsTemplate>
    <ng-container *ngIf="releaseNotes$ | async as releaseNotes">
        <ng-container *ngIf="releaseNotes.action">
            <button
                class="action link-btn"
                (click)="handleOpenDialog(releaseNotes.action)"
                [attr.data-analytics]="releaseNotes.action?.dataAnalytics?.join('-')">
                {{ releaseNotes.action?.label }}
                <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
            </button>
        </ng-container>
    </ng-container>
    <ng-template #loadingActions>
        <app-loading-skeleton [rows]="1" [rowHeight]="20"></app-loading-skeleton>
    </ng-template>
</ng-template>
